import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const searchPluginInfoRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/integrations/plugin-info',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/integrations/plugin-info' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const searchPluginInfoResponse: Json = {
    title: 'RESPONSE',
    json: [
        {
            "id": 31,
            "plugin": "Fishbowl Time",
            "table": "WO",
            "recordId": 72,
            "groupId": 10,
            "channelId": "b674f2bf-7ea2-491f-8d70-8cf4fd3243fc"
        },
        {
            "id": 32,
            "plugin": "Fishbowl Time",
            "table": "WO",
            "recordId": 72,
            "groupId": 20,
            "channelId": "27d1891e-0627-4abf-87a6-9a38db5d78f2",
            "info": {
                "id": 123
            }
        }
    ]
};

const searchPluginInfoQueryParameters: Attribute[] = [
    {
        name: 'plugin',
        type: 'string',
        description: 'The name of the plugin.',
    },
    {
        name: 'authorization',
        type: 'string',
        description: 'The user specified code for authorization.',
    },
    {
        name: 'table',
        type: 'string',
        optional: true,
        description: 'The table name in the database.',
    },
    {
        name: 'recordId',
        type: 'int',
        optional: true,
        description: 'The unique identifier for a record in Fishbowl associated with the table.',
    },
    {
        name: 'groupId',
        type: 'int',
        optional: true,
        description: 'The user specified identifier used to separate types of plugins you are using.',
    },
    {
        name: 'channelId',
        type: 'string',
        optional: true,
        description: 'The unique identifier for the object being linked externally.',
    },
];

const data: RequestDefinitionData = {
    id: 'get-plugin-info',
    title: 'Search for plugin information',
    description: 'Searches for plugin information.',
    endpoint: {
        verb: 'GET',
        path: '/integrations/plugin-info',
        tooltip: 'Search for plugin information',
    },
    attributes: [],
    requestObject: searchPluginInfoRequest,
    responseObject: searchPluginInfoResponse,
    queryParameters: searchPluginInfoQueryParameters,
}

export default data;
